export default __webpack_public_path__ + "static/media/icon_sucursales_color.3fb86061.svg";